import Vue from 'vue'
import App from './App.vue'
import publicJournal from './components/publicJournal.vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

// Push-уведомления о ходе синхронизации теперь идут через self-hosted
// WebSocket (см. ./ws.js), vue-pusher больше не используется.
// Import Bootstrap and BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

Vue.config.productionTip = false

// ?j=<token> — просмотр журнала по ссылке «Поделиться» (без входа и без
// остального интерфейса); иначе — обычное приложение
const shareToken = new URLSearchParams(window.location.search).get('j')

new Vue({
  render: h => (shareToken ? h(publicJournal, { props: { token: shareToken } }) : h(App)),
}).$mount('#app')

